import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowTrendDown,
  faArrowTrendUp,
  faArrowsLeftRight,
  faTicket,
} from "@fortawesome/free-solid-svg-icons";
import "./PieChart.css";

const NewTicketBox = ({tickets}) => {


  return (
    <div style={{ display: "flex", justifyContent: "space-around" }}>
      <div style={{ width: "30%", marginTop: "1em" }}>
        <FontAwesomeIcon style={{ width: "20%" }} icon={faTicket} />
        <h3>{tickets.totalTickets}</h3>
        <h5>Total Tickets Purchased</h5>
      </div>

      <div></div>
      <div style={{ height: "10vh", width: "30%", marginTop: "1em" }}>
        <div class="pie-chart">
          <div class="inner-circle">
            {tickets.TicketPercentageChange > 0 ? (
              <FontAwesomeIcon
                icon={faArrowTrendUp}
                style={{ color: "#26c030" }}
              />
            ) : (
              <FontAwesomeIcon icon={faArrowsLeftRight} size='lg' style={{color: "#f4da2f",}} />
            )}
          </div>
        </div>
        <h5 className="percentage">{tickets.TicketPercentageChange > 0 ? tickets.TicketPercentageChange + "%" : ''}</h5>
      </div>
    </div>
  );
};

export default NewTicketBox;
